'use client';

import Icon from './Icon';
import svg from 'sprites/yogi-man.svg';

export default function IconYogiMan({
  className='w-56 h-16 fill-none stroke-brown'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}